import axios from "../../utils/axios";
import axios1 from 'axios';
import { put } from "redux-saga/effects";
import {
  REQ_CHINESE_MEDICINE_REPORT,
  GET_CHINESE_MEDICINE_REPORT,
  GET_CHINESE_MEDICINE_DATA,
  REQ_CHINESE_MEDICINE_DATA
} from "../../store/reportStore/actionType";
import { REQ_WEST_LIST_DATA, GET_WEST_LIST_DATA } from "../../store/westMedicineStore/actionType";
import { GLOBAL_STORE } from "../../store/globalStore/actionType";


const api = {
  getChineseMedicineReport: function * ({ params }) {
    yield put ({ type: GLOBAL_STORE, store: { infoLoading: true } });
    // const res = yield axios ("/testapi/report/get_report_list", params);
    const res = yield axios ("/api/report/list", params);
    yield put ({ type: GLOBAL_STORE, store: { infoLoading: false } });
    console.log(res,2);
    if (res && res.data) {
      yield put ({ type: GET_CHINESE_MEDICINE_REPORT, report: { chineseMedicineReport: {...res.data,page:params.page} } });
    }
  },
  getChineseMedicineData: function * ({ params }) {
    yield put ({ type: GLOBAL_STORE, store: { globalLoading: true } });
    // const res = yield axios ("/testapi/report/get_score_by_time", params);
    const res = yield axios ("/api/report/healthtrend/get", params);
    yield put ({ type: GLOBAL_STORE, store: { globalLoading: false } });
    if (res && res.data) {
      yield put ({ type: GET_CHINESE_MEDICINE_DATA, report: { chineseMedicineData: res.data } });
    }
  },
  getWestMedicineDataList: function * ({ params }) {
    yield put ({ type: GLOBAL_STORE, store: { globalLoading: true } });
    const res = yield axios ("/shop/report/medi/list", params);
    yield put ({ type: GLOBAL_STORE, store: { globalLoading: false } });
    if (res && res.data) {
      const data = JSON.parse (JSON.stringify (res.data));
      switch (params.type) {
        case 1:
          yield put ({
            type: GET_WEST_LIST_DATA,
            list: { examination: data, type: 1, page: res.data.current_page }
          });
          break;
        case 2:
          yield put ({
            type: GET_WEST_LIST_DATA,
            list: { assay: data, type: 2, page: res.data.current_page }
          });
          break;
        case 3:
          yield put ({
            type: GET_WEST_LIST_DATA,
            list: { other: data, type: 3, page: res.data.current_page }
          });
          break;
        default:
          yield put ({
            type: GET_WEST_LIST_DATA,
            list: { all: data, type: 0, page: res.data.current_page }
          });
      }
    }
  },
  getChineseMedicineDataInfo: (params) => {
    //return axios ("/testapi/report/get_score_by_time", params);
    return axios ("/api/report/healthtrend/get", params);
  },
  sendReport: (params) => {
    // return axios (`/testapi/report/send_report?sid=${params.sid}`, { ...params }, false, "POST");
    return axios (`/api/report/check/send_template`, { ...params }, false, "POST");
  },
  getOssToken: (params) => {
    return axios ("/api/report/oss", params);
  },
  getOssFile(params) {
    return axios1.post(`https://${params.host}`, params.data, { headers: {} });
  },
  addReport: (params) => {
    return axios (`/shop/report/medi/add?sid=${params.sid}`, params, false, "POST");
  }
};
export { REQ_CHINESE_MEDICINE_REPORT, REQ_CHINESE_MEDICINE_DATA, REQ_WEST_LIST_DATA };
export default api;


